import { useEffect, useRef, useState } from "react";
import axios from 'axios';
import MainLayout from '../../components/layouts/MainLayout';
import Breadcrumb from '../../components/shared/Breadcrumbs';
import { useLocation } from 'react-router-dom';

const PaymentForm = () => {
  const backUrl = process.env.REACT_APP_API_URL;
  const [paymentType, setPaymentType] = useState("");
  const cardRef = useRef(null); 

  const breadcrumbs = [
    { label: "Home", path: "/" },
    { label: "投稿FORM / 決済情報入力", path: "/payment" },
  ];

  const handlePaymentTypeChange = (e) => {
    setPaymentType(e.target.value);
  }

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const postType = queryParams.get('postType');
  const postId = queryParams.get('postId');

  const handleSubmit = async () => {
    const token = localStorage.getItem('token');
  
    axios.post(`${backUrl}/api/create-checkout/`, {
      type: postType,
      post_id: Number(postId),
      payment_type: paymentType,
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`,
      }
    })
    .then(response => {
      console.log("有料投稿検証完了", response.data);
      window.location.href = response.data.url
    })
    .catch(error => {
      console.error("有料投稿検証エラー:", error);
    });
  };

  return (
    <MainLayout>
      <Breadcrumb items={breadcrumbs} />
      <div className="payment__text">
        <h2>投稿が完了いたしました。</h2>
        <h3>お支払いお手続きへ進みます</h3>
        <p>必要情報を入力し登録するボタンを押してください</p>
      </div>
      <div>
      <div className="payment__form-radio">
        <label className="payment__form-radio-label">期間を選択してください</label>
        <div className="payment__form-radio-group">
          <label className="payment__form-radio-input">
            <input
              type="radio"
              name="paymentType"
              value="1"
              checked={paymentType === '1'}
              onChange={handlePaymentTypeChange}
            />
            １週間 / $20
          </label>
          <label className="payment__form-radio-input">
            <input
              type="radio"
              name="paymentType"
              value="2"
              checked={paymentType === '2'}
              onChange={handlePaymentTypeChange}
            />
            ２週間 / $35
          </label>
          <label className="payment__form-radio-input">
            <input
              type="radio"
              name="paymentType"
              value="3"
              checked={paymentType === '3'}
              onChange={handlePaymentTypeChange}
            />
            ３週間 / $50
          </label>
          <label className="payment__form-radio-input">
            <input
              type="radio"
              name="paymentType"
              value="4"
              checked={paymentType === '4'}
              onChange={handlePaymentTypeChange}
            />
            ４週間 / $60
          </label>
        </div>
      </div>
      <button className='payment__form-submit' onClick={handleSubmit}>登録する</button>
    </div>
    </MainLayout>
  );
};

export default PaymentForm;
